import { render, staticRenderFns } from "./BookEventDlg.vue?vue&type=template&id=00dd8d98&scoped=true"
import script from "./BookEventDlg.ts?vue&type=script&lang=ts&external"
export * from "./BookEventDlg.ts?vue&type=script&lang=ts&external"
import style0 from "./BookEventDlg.scss?vue&type=style&index=0&id=00dd8d98&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dd8d98",
  null
  
)

export default component.exports